import { fi } from "../../../../date-fns/locale/fi.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    fi
  }
};